import '@/containers/Promotions/components/SelectionModalContent/_selectionModalContent.scss'
import GTINSContent from '@/containers/Promotions/components/SelectionModalContent/GTINSContent/GTINSContent'
import {BuyType} from '@/utils/constants/promotionConstants'
import DropdownSelectionContent from './DropdownSelectionContent'
import ProductIdContentV2 from './ProductIdContentV2'

const SelectionModalContentV2 = ({type, selectionModalHookValue, isExclude}) => {
  const {activeTabIndex, selectedTags, combination, tabs, onTabChange, setSelectedTags, setCombination} =
    selectionModalHookValue

  if (BuyType.CATEGORY === type) {
    return (
      <DropdownSelectionContent
        type={type}
        activeTabIndex={activeTabIndex}
        selectedTags={selectedTags}
        tabs={tabs}
        onTabChange={onTabChange}
        setSelectedTags={setSelectedTags}
      />
    )
  }

  if (type === BuyType.PRODUCT || type === BuyType.BRAND) {
    return (
      <DropdownSelectionContent
        type={type}
        activeTabIndex={activeTabIndex}
        selectedTags={selectedTags}
        tabs={tabs}
        onTabChange={onTabChange}
        setSelectedTags={setSelectedTags}
      />
    )
  }

  if (type === BuyType.GTINS) {
    return (
      <GTINSContent
        onSelection={setSelectedTags}
        setCombination={setCombination}
        selectedGtins={selectedTags.itemType === BuyType.GTINS ? selectedTags.values : []}
        combination={combination}
        isExclude={isExclude}
      />
    )
  }

  if (type === BuyType.PRODUCT_ID || type === BuyType.COMBO_ID) {
    return (
      <div className="selection-modal-content">
        <ProductIdContentV2
          onSelection={setSelectedTags}
          setCombination={setCombination}
          combination={combination}
          isExclude={isExclude}
          selectedValues={selectedTags.itemType === type ? selectedTags.values : []}
          type={type}
        />
      </div>
    )
  }
}

export default SelectionModalContentV2
